export default class AttachedDeviceModel {
    public coreId: string;
    public attachedDeviceId: string;
    public attachedDeviceName: string;
    public attachedDeviceTypeId: number;
    public alarm1: boolean;
    public alarm2: boolean;
    public tampered: boolean;
    public battery: number;
    public reporting: boolean;
    public reportingRestored: boolean;
    public failure: boolean;
    public acMainsFault: boolean;
    public testMode: boolean;
    public batteryDefect: boolean;
    public age: number;
    public deviceTypeDescription: string;
    public latestEventName: string;
    public modifiedDateTime: Date;
    public insertedDateTime: string;
    public minutesSinceLastHeartBeat: string;
    public status?: boolean | null;
    public stableStatus?: boolean | null;
    public pairedAt?: number;
    public isConnecting: boolean = false;
    public isPinging: boolean = false;
}